import Link from "next/link";
import { useTranslations } from "next-intl";

import { useNotificationsPanelOptions } from "@/components/doc/left-sidebar/top-menu/notifications/NotificationsPanelOptions";
import { chatPageUrl, docPageUrl, teamPageUrl } from "@/urls";
import { twMerge } from "@/utils/twMerge";

import type { Notification } from "@/api";
import type { MessageKeys, NestedKeyOf } from "next-intl";

export function NotificationText({
  notification,
  docId,
  docTitle,
  chatUid,
  chatTitle,
  messageUid,
  copyKey,
}: {
  notification: Notification;
  docId?: string;
  docTitle?: string | null;
  chatUid?: string | null;
  chatTitle?: string | null;
  messageUid?: string | null;
  copyKey: MessageKeys<
    IntlMessages["sidebar"]["notifications"],
    NestedKeyOf<IntlMessages["sidebar"]["notifications"]>
  >;
}) {
  const t = useTranslations();
  const { disableTruncate } = useNotificationsPanelOptions();

  return (
    <p
      className={twMerge(
        "text-[15px] leading-[18px] tracking-[-0.02em]",
        !disableTruncate && "truncate",
      )}
    >
      {t.rich(`sidebar.notifications.${copyKey}`, {
        senderName: notification.sender.name,
        name: docTitle || t("doc.documentTitle.placeholder"),
        chatTitle: chatTitle || t("chat.untitledChat"),
        user: (chunks) => (
          <Link
            href={teamPageUrl({ teamPermalink: notification.sender.username })}
            className="relative font-semibold hover:underline"
          >
            {chunks}
          </Link>
        ),
        document: (chunks) =>
          docId ? (
            <Link
              href={docPageUrl({
                docId,
                chat: chatUid ?? undefined,
                message: messageUid ?? undefined,
              })}
              className="relative font-semibold hover:underline"
            >
              {chunks}
            </Link>
          ) : (
            <span className="font-semibold">{chunks}</span>
          ),
        chat: (chunks) =>
          chatUid ? (
            <Link
              href={chatPageUrl({ chatId: chatUid })}
              className="relative font-semibold hover:underline"
            >
              {chunks}
            </Link>
          ) : (
            <span className="font-semibold">{chunks}</span>
          ),
      })}
    </p>
  );
}
